import { Route } from '@angular/router';
import { InfoComponent } from './info.component';

export const infoRoutes: Route[] = [
    {
        path: 'info',
        component: InfoComponent, // Load the InfoComponent directly
    },
];
